import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import classnames from 'classnames';

import { getReservationTimeFromTimeItem } from '../../utils/helpers';
import { timeShape } from '../../shapes';

const TimeSlot = ({ item, timezone, selectedTime, setTime }) => {
  const reservationTime = getReservationTimeFromTimeItem(item);
  const date = moment.tz(item.time, timezone);
  const time = date.format('h:mm[\n]A');

  const className = classnames(
    'c-time-slider__item',
    { 'is-active': reservationTime === selectedTime },
  );

  return (
    <button
      className={className}
      onClick={setTime(item)}
    >
      {time}
    </button>
  );
};

TimeSlot.propTypes = {
  item: timeShape.isRequired,
  timezone: PropTypes.string.isRequired,
  setTime: PropTypes.func.isRequired,
  selectedTime: PropTypes.string.isRequired,
};
TimeSlot.defaultProps = {};

export default TimeSlot;



// WEBPACK FOOTER //
// ./src/app/times/components/TimeSlot.jsx